import React, { useState , useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
import { useSelector } from 'react-redux';
import {
  Button,
  TextField,
  TextareaAutosize,
  FormControl,
  InputLabel,
  MenuItem,
  RadioGroup,
  Radio,
  ListItemIcon,
  Checkbox,
  ListItemText,
  FormLabel,
  FormControlLabel,
} from "@mui/material";
import {
  convertValuesToTarget,
  graphTypes,
  kpiTypes,
  labels,
  monitoringOptions,
} from "../../../../utils/useWindowDimensions";


const CreateKPI = ({ show, handleClose, kpi, setKPI, error, submit }) => {

  const configData = useSelector(state => state.configSlice);
  const userData = useSelector(state => state.userSlice);
  const [monitoringData, setMonitoringData] = useState([]);
  const [monitoringValue, setMonitoringValue] = useState([]);
  const [targetError, setTargetError] = useState(null);
  const [titleError, setTitleError] = useState(null);
  const [monitoringError, setMonitoringError] = useState(null);

  const setDuration = (index, data) => {
    setMonitoringValue([]);
    var parameters = kpi.parameters;
    parameters[index] = {
      ...parameters[index],
      ...data,
      values: Array(labels[data.duration].length).fill(0),
    };
    setKPI({ ...kpi, parameters: parameters });
    let array = convertValuesToTarget( monitoringData,  data.duration ,  "MONTHLY" );
    setMonitoringValue(array);

  };

  const setParameterValue = (index, valueIndex, value) => {
    var parameters = kpi.parameters;
    parameters[index].values[valueIndex] = value;
    setKPI({ ...kpi, parameters: parameters });
  };

  const setParameterName = (index, value) => {
    var parameters = kpi.parameters;
    parameters[index].name = value;
    setKPI({ ...kpi, parameters: parameters });
  };

  const setMetricType = async(index, type) => {
    try {

    var parameters = kpi.parameters;
    parameters[index].type = type;
    parameters[index].name = monitoringOptions[type] ;

    if(index == 1){
      setMonitoringValue([]);
      setMonitoringData([]);
      parameters[index].values = Array(labels[parameters[index].duration].length).fill(0)
      }

    setKPI({
      ...kpi,
      parameters: parameters,
    });

    if( index == 1 && (type == "TOTAL_TRAININGS" || type == "ACTIVE_USERS" || type =="CERTIFIED_USERS" )){
        let _data={
          groupId : userData.user.group.uuid,
           applicationId: configData.config.applicationId
        }

         let { data } = await axios.post(`${configData.config.API_URL}/api/kpi/parameter/values/${type}`, _data, {
                        headers: {Authorization: `Bearer ${userData.token}`}
                    });

        setMonitoringData(data.data);
        let array = convertValuesToTarget( data.data,  kpi.parameters[1].duration ,  "MONTHLY" );
        setMonitoringValue(array);

    }

  } catch (error) {
       console.log(error.message);
  }

  };

  useEffect(()=>{
    setMonitoringError(null);
    setTargetError(null);
    setTitleError(null)
  },[show])

  useEffect(()=>{
    if(monitoringValue.length){
      monitoringValue.map((e, index)=>{
        setParameterValue(
          1,
          index,
          parseFloat(e)
        )});
      }
  },[monitoringValue]);

  const handleSubmit = () =>{
       let noError = true;
       setTitleError(null);
       setMonitoringError(null);
       setTargetError(null);
       
        if (kpi.title.trim() === "") {
          noError = false;
          setTitleError("Enter a valid KPI Title.")
        }

       if (kpi.parameters[0].type === "CUSTOM") {
        if (!kpi.parameters[0].name || kpi.parameters[0].name.trim() === "") {
          noError = false;
          setTargetError("Fill this field.")
        }
      }
    
      if (kpi.parameters[1].type === "CUSTOM") {
        if (!kpi.parameters[1].name || kpi.parameters[1].name.trim() === "") {
          noError = false;
          setMonitoringError("Fill this field.")
        }
      }

       if(noError){ submit() }

       setTimeout(() => {
        setMonitoringError(null);
       setTargetError(null);
       setTitleError(null)
       }, 3000);
  }

  return (
    <>
      <Modal
        size="lg"
        className="passsign-center createkpi"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <p className="kpititle">Create KPI</p>
              <div className="col-md-12">
                <div className="quesformbox mt-3">
                  <p>KPI Title</p>
                  <input
                    disabled={kpi.id}
                    name="minimumSuccess"
                    value={kpi.title}
                    onChange={(e) => setKPI({ ...kpi, title: e.target.value })}
                    placeholder="KPI Title"
                    type="text"
                    className="input mt-2"
                  ></input>
                  {/* <p className="errors">{error}</p> */}
                  <p className="errors">{titleError}</p>
                </div>
              </div>

              <div className="col-md-12">
                <div className="questype mt-1">
                  <FormControl
                    fullWidth
                    className="mb-3 d-flex align-items-center passmodal"
                  >
                    <RadioGroup
                      row
                      aria-labelledby="price-visibility-label"
                      name="questionType"
                      value={kpi.graphType}
                      onChange={(e) =>
                        setKPI({ ...kpi, graphType: e.target.value })
                      }
                    >
                      {Object.keys(graphTypes).map((value, i) => (
                        <FormControlLabel
                          className="quizlabel"
                          value={value}
                          control={<Radio />}
                          label={graphTypes[value]}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <div className="col-md-12">
                <div className="questype mt-2">
                  <p>Target Duration</p>
                  <FormControl
                    fullWidth
                    disabled={kpi.id}
                    className="mb-3 d-flex align-items-center passmodal"
                  >
                    <RadioGroup
                      row
                      aria-labelledby="price-visibility-label"
                      name="questionType"
                      value={kpi.parameters[0].duration}
                      onChange={(e) =>
                        setDuration(0, { duration: e.target.value })
                      }
                    >
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.MONTHLY}
                        control={<Radio />}
                        label="Monthly"
                      />
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.QUARTERLY}
                        control={<Radio />}
                        label="Quarterly"
                      />
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.YEARLY}
                        control={<Radio />}
                        label="Yearly"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <div className="col-md-12">
                <div className="quesformbox mt-3">
                  <p>Target Metric</p>
                  <select
                    disabled={kpi.id}
                    value={kpi.parameters[0].type}
                    className="form-select"
                    onChange={(e) => setMetricType(0, e.target.value)}
                    aria-label="Default select example"
                  >
                    {Object.keys(monitoringOptions).map((value) => (
                      <option value={value} key={value}>
                        {monitoringOptions[value]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-12">
                <div className="quesformbox mt-0">
                  {kpi.parameters[0].type === "CUSTOM" ? (
                    <>
                    <input
                      style={{ height: "30px", fontSize: "13px" }}
                      value={kpi.parameters[0].name}
                      onChange={(e) => setParameterName(0, e.target.value)}
                      name="minimumSuccess"
                      placeholder="Parameter Name"
                      type="text"
                      className="input mt-0"
                    /> 
                    <p className="errors"> {targetError} </p>
                   </>
                   ) : null}
                </div>
              </div>

              <div className="col-md-12">
                <div className="questype mt-1">
                  <p>Monitoring Duration</p>
                  <FormControl
                    disabled={kpi.id}
                    fullWidth
                    className="mb-3 d-flex align-items-center passmodal"
                  >
                    <RadioGroup
                      row
                      aria-labelledby="price-visibility-label"
                      name="questionType"
                      value={kpi.parameters[1].duration}
                      onChange={(e) => setDuration(1, { duration: e.target.value }) }
                    >
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.MONTHLY}
                        control={<Radio />}
                        label="Monthly"
                      />
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.QUARTERLY}
                        control={<Radio />}
                        label="Quarterly"
                      />
                      <FormControlLabel
                        className="quizlabel"
                        value={kpiTypes.YEARLY}
                        control={<Radio />}
                        label="Yearly"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <div className="col-md-12">
                <div className="quesformbox mt-3">
                  <p>Monitoring Metric</p>
                  <select
                    disabled={kpi.id}
                    value={kpi.parameters[1].type}
                    className="form-select"
                    onChange={(e) => setMetricType(1, e.target.value)}
                    aria-label="Default select example"
                  >
                    {Object.keys(monitoringOptions).map((value) => (
                      <option value={value} key={value}>
                        {monitoringOptions[value]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-12">
                <div className="quesformbox mt-0">
                  {kpi.parameters[1].type === "CUSTOM" ? (
                    <>
                    <input
                      style={{ height: "30px", fontSize: "13px" }}
                      value={kpi.parameters[1].name}
                      onChange={(e) => setParameterName(1, e.target.value)}
                      name="minimumSuccess"
                      placeholder="Parameter Name"
                      type="text"
                      className="input mt-0"
                    />
                    <p className="errors"> {monitoringError} </p>
                    </>
                  ) : null}
                </div>
              </div>

             
            </div>

            <div className="col-md-6">
              <p className="kpititle para">Parameter Values</p>
              <div className="row">
                <div className="col-md-6">
                  <div className="KPIheader">
                    <p>Target Values</p>
                    {labels[kpi.parameters[0].duration].map((label, index) => {
                      return (
                        <input
                          disabled={kpi.parameters[0].type !== "CUSTOM"}
                          value={kpi.parameters[0].values[index]}
                          onChange={(e) =>
                            setParameterValue(
                              0,
                              index,
                              parseFloat(e.target.value)
                            )
                          }
                          name="minimumSuccess"
                          placeholder={label}
                          type={"number"}
                          className="input mt-2"
                        ></input>
                      );
                    })}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="KPIheader">
                    <p>Monitoring Values</p>
                    {labels[kpi.parameters[1].duration].map((label, index) => {
                      return (
                        <input
                          disabled={kpi.parameters[1].type !== "CUSTOM"}
                          value={kpi.parameters[1].values[index]}
                          onChange={(e) =>
                            setParameterValue(
                              1,
                              index,
                              parseFloat(e.target.value)
                            )
                          }
                          name="minimumSuccess"
                          placeholder={label}
                          type={"number"}
                          className="input mt-2"
                        ></input>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
                <div className="footerbtn text-end mt-2 pt-2">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="cancel"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  {/* <button className="loading save">
                    <svg viewBox="25 25 50 50">
                      <circle r="20" cy="50" cx="50"></circle>
                    </svg>
                  </button> */}
                  <button
                    type="button"
                    onClick={() => handleSubmit()}
                    className="save"
                  >
                    {kpi.id ? "Update" : "Create"}
                  </button>
                </div>
              </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateKPI;

